export const PROGRESS_COLORS = {
    DEFAULT: {
        fill: 'var(--palette-gray-30)',
        stroke: 'var(--palette-gray-30)',
    },
    PROGRESS: {
        fill: 'var(--palette-teal-70)',
        stroke: 'var(--palette-teal-70)',
    },
    SUCCESS: {
        fill: 'var(--palette-green-50)',
        stroke: 'var(--palette-green-50)',
    },
    WARNING: {
        fill: 'var(--palette-yellow-70)',
        stroke: 'var(--palette-yellow-70)',
    },
    ERROR: {
        fill: 'var(--palette-red-70)',
        stroke:  'var(--palette-red-120)',
    },
};
